import React from 'react';
import { addAllItemToSelectList, convertTextToShort, setColumnWidth } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import Select from '../../../../../components/input/Select';
import OpenNoticeProductDetail from '../../../../../components/link/OpenNoticeProductDetail';
import OpenNoticeProductItem from '../../../../../containers/app/common/OpenNoticeProductItem';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import Button from '../../../../../components/Button';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { NOTICE_PRODUCT_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import {
  NOTICE_PRODUCT_STATUS_TEXT,
  NOTICE_PRODUCT_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/noticeProductConstants';
import { setDetailPageUrl, openNewWindow } from '../../../../../lib/common';

/**
 *  브랜드의 상품 공지사항 리스트
 */
const columns = (data) => {
  const { list, filterOption, onFilter } = data;

  return [
    {
      Header: '상세보기',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="상세보기"
          onClick={() => openNewWindow(setDetailPageUrl(NOTICE_PRODUCT_DETAIL_URL_PATH, row.original.id))}
        />
      ),
    },
    {
      Header: '상품 공지사항ID',
      fixed: 'left',
      width: 100,
      Cell: (row) => <OpenNoticeProductDetail text={row.original.id} noticeProductId={row.original.id} />,
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => NOTICE_PRODUCT_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(NOTICE_PRODUCT_TYPE_SELECT_LIST)}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'title',
      Header: '제목',
      resizable: true,
      filterable: true,
      width: setColumnWidth(list, 'title'),
      Filter: () => <TableFilterInput option={filterOption.title} onFilter={(title) => onFilter({ title })} />,
    },
    {
      accessor: 'content',
      Header: '내용',
      filterable: true,
      width: 300,
      Cell: (row) => (
        <OpenPreviewProductDetail
          text={convertTextToShort(row.value, 30)}
          storeId={row.original.storeId}
          storeName={row.original.storeName}
          noticeContent={row.value}
          productNoticeId={row.original.id}
          disabledActiveValue={true}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.content} onFilter={(content) => onFilter({ content })} />,
    },
    {
      accessor: 'memo',
      Header: '메모',
      filterable: true,
      width: 300,
      Cell: (row) => convertTextToShort(row.value, 30),
      Filter: () => <TableFilterInput option={filterOption.memo} onFilter={(memo) => onFilter({ memo })} />,
    },
    {
      accessor: 'registeredProductCount',
      Header: '등록된 상품',
      Cell: (row) => <OpenNoticeProductItem productNoticeId={row.original.id} productCount={row.value} />,
    },
    {
      accessor: 'period',
      Header: '노출 기간',
      filterable: true,
      width: 320,
      Filter: () => (
        <DateRangePicker
          value={filterOption.period}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ period: data })}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '작성일',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
  ];
};

export default columns;
